import { useContext, useEffect } from 'react';

import { observer } from 'mobx-react-lite';

import { RootStoreContext } from 'index';
import Spinner from 'components/common/Spinner/Spinner';

import CompanyEmailNotificationTable from './companyEmailNotificationTable';
import styles from './CompanyNotifications.module.scss';

const CompanyNotifications = () => {
  const { companyNotificationsStore } = useContext(RootStoreContext);
  const { isLoading, fetchNotifications } = companyNotificationsStore;

  const getInitialData = async () => {
    await fetchNotifications();
  };

  useEffect(() => {
    getInitialData();
  }, []);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div className={styles.mainPageContainer}>
      <div className={styles.mainText}>
        <div className={styles.mainHeader}>Company Notifications</div>
        <div className={styles.adviceLabel}>
          Use the below table to choose which loan status emails you want to receive for each of your businesses email
          addresses. Only list email addresses below that are not intended to go to an individual user’s email account.
          Use this section for general notifications to distribution lists or shared email mailboxes. If you wish to add
          an individual user, please add them to the users section.
        </div>
      </div>
      <CompanyEmailNotificationTable />
    </div>
  );
};

export default observer(CompanyNotifications);
